import { UI } from '@/Components/UI';
import { useDynamicInputs } from '@/hooks';
import { IngredientsForm } from '@/Components/Specific/Recipe/Form/IngredientsForm';
import { MeasuringUnit } from '@/types';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

export const IngredientGroupsForm = () => {
    const { t } = useTranslation(['recipes']);
    const { addValue, removeValue, values } = useDynamicInputs('ingredientGroups', {
        title: '',
        ingredients: [
            {
                amount: 0,
                measuringUnit: 'UNKNOWN' as MeasuringUnit,
                food: { name: '' }
            }
        ]
    });

    useEffect(() => {
        if (!values || values.length === 0) {
            addValue();
        }
    }, [values]);

    return (
        <>
            <UI.Heading level={2}>
                {t('form.ingredientGroups.heading')}
            </UI.Heading>

            <div className={'flex flex-col gap-2 mb-2'}>
                {values?.map((_, index) => (
                    <div
                        key={index}
                        className={'flex flex-col gap-3 px-4 py-2 rounded-lg border border-primary'}>
                        <UI.Form.Input
                            name={`ingredientGroups.${index}.title`}
                            label={t('form.ingredientGroups.groupTitle')} />

                        <div className={'text-end'}>
                            <UI.Button
                                buttonStyle={'tonal'}
                                type={'button'}
                                onClick={() => removeValue(index)}>
                                <UI.Icon name={'delete'} />
                            </UI.Button>
                        </div>

                        <IngredientsForm
                            groupIndex={index} />
                    </div>
                ))}

                <UI.Button
                    buttonStyle={'tonal'}
                    type={'button'}
                    onClick={addValue}>
                    <UI.Icon name={'add'} />
                </UI.Button>
            </div>
        </>
    );
};
